import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CvContainer } from "./CVContainer/CvContainer";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className={"App"}>
      <ToastContainer />
      <CvContainer />
    </div>
  );
}

export function Application() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
}
